var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBehaviorChip2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 21.3333,
    height: 21.3333,
    viewBox: "0 0 21.3333 21.3333",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "paw"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 10.2203C5.2273 10.2203 6.22222 9.22533 6.22222 7.99804C6.22222 6.77074 5.2273 5.77581 4 5.77581C2.7727 5.77581 1.77778 6.77074 1.77778 7.99804C1.77778 9.22533 2.7727 10.2203 4 10.2203Z",
    fill: "#14CD71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6.6647C9.2273 6.6647 10.2222 5.66978 10.2222 4.44248C10.2222 3.21518 9.2273 2.22026 8 2.22026C6.7727 2.22026 5.77778 3.21518 5.77778 4.44248C5.77778 5.66978 6.7727 6.6647 8 6.6647Z",
    fill: "#14CD71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 6.6647C14.5606 6.6647 15.5556 5.66978 15.5556 4.44248C15.5556 3.21518 14.5606 2.22026 13.3333 2.22026C12.106 2.22026 11.1111 3.21518 11.1111 4.44248C11.1111 5.66978 12.106 6.6647 13.3333 6.6647Z",
    fill: "#14CD71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 10.2203C18.5606 10.2203 19.5556 9.22533 19.5556 7.99804C19.5556 6.77074 18.5606 5.77581 17.3333 5.77581C16.106 5.77581 15.1111 6.77074 15.1111 7.99804C15.1111 9.22533 16.106 10.2203 17.3333 10.2203Z",
    fill: "#14CD71"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4133 12.7625C14.64 11.8558 13.9911 11.0825 13.2089 10.1758C12.8 9.69581 12.2756 9.21581 11.6533 9.00248C11.5556 8.96692 11.4578 8.94026 11.36 8.92248C11.1378 8.88692 10.8978 8.88692 10.6667 8.88692C10.4356 8.88692 10.1956 8.88692 9.96445 8.93137C9.86667 8.94915 9.76889 8.97581 9.67111 9.01137C9.04889 9.2247 8.53333 9.7047 8.11556 10.1847C7.34222 11.0914 6.69333 11.8647 5.91111 12.7714C4.74667 13.9358 3.31556 15.2247 3.58222 17.0291C3.84 17.9358 4.48889 18.8336 5.65333 19.0914C6.30222 19.2247 8.37333 18.7003 10.5778 18.7003H10.7378C12.9422 18.7003 15.0133 19.2158 15.6622 19.0914C16.8267 18.8336 17.4756 17.9269 17.7333 17.0291C18.0089 15.2158 16.5778 13.9269 15.4133 12.7625Z",
    fill: "#14CD71"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBehaviorChip2);
export default __webpack_public_path__ + "static/media/behavior-chip-2.5286a6d4bd8fc5a49993d6847d7df442.svg";
export { ForwardRef as ReactComponent };